import axios from "axios";
import { promiseWp } from "@/comm/js/promiseExt";

const URLMAP = {
  GET_RESUME: "web/resume/my",
  POST_UPLOAD_GRADE_PROVE: "web/resume/scoreProve/upload"
};

/**
 * 获取简历信息 可用于判断登录状态
 * @param {*} data
 * @returns
 */
export const getLoginStatus = data =>
  promiseWp(axios.get(URLMAP.GET_RESUME, { params: data, passLogin: 1 }));
/**
 * 成绩证明上传
 */
export const uploadGradeProve = data =>
  promiseWp(
    axios.post(URLMAP.POST_UPLOAD_GRADE_PROVE, data, {
      headers: {
        "content-type": "multipart/form-data"
      }
    })
  );

/**
 * 作品上传
 */
export const uploadWorkFiles = (data, resumeId) =>
  promiseWp(
    axios.post(`web/resume/works/upload/${resumeId}`, data, {
      headers: {
        "content-type": "multipart/form-data"
      }
    })
  );

/**
 * 作品删除
 */
export const deleteWorkFiles = (resumeId, workId) =>
  promiseWp(axios.delete(`web/resume/works/remove/${resumeId}/${workId}`));

export const transferAccountData = (data) => promiseWp(axios.post(`web/resume/transfer/account-data`, data));



// WEBPACK FOOTER //
// ./src/apis/resume.js